import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import { HelpHint } from "@/components/HelpHint";
import { formatDate } from "@/lib/helpers";
import { Receipt } from "lucide-react";

// Charges only ever carry a "waived"/"pending" status of interest for the
// badge here; anything else (e.g. paid-off/settled) reads as "active".
// Extracted out of JSX to avoid a nested ternary.
const chargeBadgeStatus = (status) => {
  if (status === "waived") return "waived";
  if (status === "pending") return "pending";
  return "active";
};

// Student Detail -> "Charges" card (staff only). Extracted from
// StudentDetail.js (props-driven, no behavior change).
export const ChargesCard = ({ charges, onWaiveCharge }) => (
  <section className="rounded-[var(--radius)] border bg-card p-4 sm:p-5 space-y-3" data-testid="charges-section">
    <div className="flex items-center gap-1.5">
      <h2 className="font-semibold font-heading flex items-center gap-2"><Receipt className="h-4 w-4" /> Charges</h2>
      <HelpHint text="Late-cancellation fees are added here automatically as a pending charge. Waive one anytime as a goodwill exception." testId="charges-help" />
    </div>
    {charges.length === 0 ? (
      <p className="text-sm text-muted-foreground">No charges yet.</p>
    ) : (
      <div className="divide-y">
        {charges.map((c) => (
          <div key={c.id} className="flex items-center justify-between py-2 gap-2" data-testid="student-charge-row">
            <div className="min-w-0">
              <p className="text-sm font-medium truncate">{c.description}</p>
              <p className="text-xs text-muted-foreground">
                {formatDate(c.created_at)}{c.source === "cancellation_fee" ? " · Auto-applied cancellation fee" : ""}
              </p>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <span className="text-sm font-medium tabular-nums">${c.amount.toFixed(2)}</span>
              <StatusBadge status={chargeBadgeStatus(c.status)} />
              {c.status === "pending" && (
                <Button size="sm" variant="ghost" onClick={() => onWaiveCharge(c.id)} data-testid="waive-charge-button">Waive</Button>
              )}
            </div>
          </div>
        ))}
      </div>
    )}
  </section>
);
